(function ($) {
	// On Dom Ready
	$(function () {
	
		if( $('.block-photoslider .swiper').length == 0 ){
			return;
		}
		
		$('.block-photoslider .swiper').each( function(){
			$(this).data('autoplay', true);
			var photosliderSwiper = new Swiper($(this)[0], {
				// Optional parameters
				loop: true,
				slidesPerView: 1,
				lazy: true,
				simulateTouch: false,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},

				autoplay: {
					delay: 5000
				},
				speed: 700,

				// If we need pagination
				pagination: false,

				// Navigation arrows
				navigation: {
					nextEl: $('.swiper-button-next', this)[0],
					prevEl: $('.swiper-button-prev', this)[0],
				},

			});
		});
	
		// Toggle slide play/pause
		$('.block-photoslider .btn-play-pause').on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass("active");
			
			var targetSwiper = $(this).closest('.swiper');

			if( targetSwiper.data('autoplay') == true ) {
				targetSwiper[0].swiper.autoplay.stop();
				targetSwiper.data('autoplay', false);
			} else {
				targetSwiper[0].swiper.autoplay.start();
				targetSwiper.data('autoplay', true);
			}
			
		});

	});
})(jQuery);
